<template>
    <v-layout>
        <v-flex xs12>
            <v-card>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Details</h1>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex xs12>
                        <v-alert
                          v-model="infoVisible"
                          outline
                          dismissible
                          type="info">
                          You must remove all products from the order before changing the order details, as this may affect which products are available.
                        </v-alert>
                    </v-flex>
                </v-layout>
                <v-form v-model="orderFormValid" ref="orderForm">
                    <v-layout row wrap v-if="orderProducts.length > 0 || !isOrdersProductsCommentsEmpty">
                        <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                            <v-select
                                :items="stores"
                                item-text="Name"
                                item-value="ID"
                                v-model="order.StoreID"
                                :rules="[rules.selectIDRequired]"
                                label="Store"
                                hint="Store"
                                readonly
                                append-icon="info"
                                @click:append="showInfo"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                            <v-select
                                :items="departmentsInSelectedStore"
                                item-text="Name"
                                item-value="ID"
                                v-model="order.DepartmentID"
                                :rules="[rules.selectIDRequired]"
                                label="Department"
                                hint="Department"
                                readonly
                                append-icon="info"
                                @click:append="showInfo"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                            <v-text-field
                                v-model="order.Date"
                                label="Order Date"
                                prepend-icon="event"
                                hint="Order Date"
                                :rules="[rules.required]"
                                readonly
                                append-icon="info"
                                @click:append="showInfo"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="orderProducts.length == 0 && isOrdersProductsCommentsEmpty">
                        <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                            <v-select
                                :items="stores"
                                item-text="Name"
                                item-value="ID"
                                v-model="order.StoreID"
                                :rules="[rules.selectIDRequired]"
                                label="Store"
                                hint="Store"
                                @change="orderDetailsChanged"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                            <v-select
                                :items="departmentsInSelectedStore"
                                item-text="Name"
                                item-value="ID"
                                v-model="order.DepartmentID"
                                :rules="[rules.selectIDRequired]"
                                label="Department"
                                hint="Department"
                                @change="orderDetailsChanged"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md4 :class="{'formSpacing':$vuetify.breakpoint.mdAndUp}">
                            <v-menu
                                ref="datePickerMenu"
                                :close-on-content-click="false"
                                v-model="datePickerMenu"
                                :nudge-right="40"
                                lazy
                                transition="scale-transition"
                                offset-y
                                full-width
                                min-width="290px">
                                <v-text-field
                                    clearable
                                    slot="activator"
                                    v-model="order.Date"
                                    label="Order Date"
                                    prepend-icon="event"
                                    hint="Order Date"
                                    :rules="[rules.required]"
                                    readonly
                                ></v-text-field>
                                <v-date-picker 
                                    :allowed-dates="allowedDates"
                                    v-model="order.Date"
                                    @input="onDateInput">
                                </v-date-picker>
                            </v-menu>
                        </v-flex>
                    </v-layout>
                </v-form>
                <v-layout class="dialog-action-buttons">
                    <v-flex xs12>
                        <v-btn block color="info" :loading="suppliersLoading" @click="printOrderSheet()" :disabled="!orderFormValid">Print Order Sheet</v-btn>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card v-if="orderFormValid && suppliersLoading">
                <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-card>
            <v-card v-if="orderFormValid && !suppliersLoading && supplierLoadError">
                <v-alert outline :value="true" color="error" icon="error">
                    {{supplierLoadError}}
                </v-alert>
            </v-card>
            <v-card v-if="orderFormValid && !suppliersLoading && !supplierLoadError && !orderHasSuppliers && !placeOrderError">
                <v-alert outline :value="true" type="info">
                    No products have been assigned suppliers for <span v-if="selectedStore">{{selectedStore.Name}}</span><span v-if="!selectedStore">this store</span> on <span v-if="order.Date">{{formatDate(order.Date)}}</span><span v-if="!order.Date">this date</span> which are in categories for <span v-if="selectedDepartment">{{selectedDepartment.Name}}</span><span v-if="!selectedDepartment">this department</span>.
                </v-alert>
            </v-card>
            <v-card v-if="placeOrderError">
                <v-alert outline :value="true" color="error" icon="error">
                    {{placeOrderError}}
                </v-alert>
            </v-card>
            <v-card v-if="orderFormValid && !suppliersLoading && !supplierLoadError && orderHasSuppliers">
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Items</h1>
                    </v-flex>
                </v-layout>
                <OrderItemsForm ref="orderItemsForm" :showStockEntry="showStockEntry"></OrderItemsForm>
            </v-card>
            <v-card v-if="orderFormValid && !suppliersLoading && !supplierLoadError && orderHasSuppliers">
                <v-layout wrap class="dialog-action-buttons">
                    <v-flex xs12 md6>
                        <v-btn block color="success" :disabled="(!orderFormValid || orderProducts.length == 0) && isOrdersProductsCommentsEmpty" :loading="placing" @click="saveOrder">Save Order</v-btn>
                    </v-flex>
                    <v-flex xs12 md6>
                        <v-btn block color="success" :disabled="!orderFormValid || orderProducts.length == 0" :loading="placing" @click="placeOrder">Place Order</v-btn>
                    </v-flex>
                    <v-flex xs12>
                        <error-alert :content="placeError" :display="placeError"></error-alert>
                    </v-flex>
                </v-layout>     
            </v-card>                       
        </v-flex>
    </v-layout>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';
import util from '@/services/util';
import orderUtil from '@/services/orderUtil';
import OrderItemsForm from './OrderItemsForm';

export default {
    components: {
        ErrorAlert,
        OrderItemsForm
    },
    props: [
        'loading',
        'placing',
        'placeError',
    ],
    data() {
        return {
            infoVisible: false,
            orderFormValid: false,
            rules: validationRules.rules,
            datePickerMenu: false,
            placeOrderError: "",
            showStockEntry:false
        };
    },
    computed: {
        order(){
            return this.$store.state.placeOrderStore.order;
        },
        orderProducts(){
            return this.$store.state.placeOrderStore.orderProducts;
        },
        ordersProductsComments(){
            return this.$store.state.placeOrderStore.ordersProductsComments;
        },
        isOrdersProductsCommentsEmpty() {
            return this.ordersProductsComments == null || this.ordersProductsComments.find(comment => {return comment.Comments && comment.Comments != ''}) == null
        },
        orderSuppliers(){
            return this.$store.state.placeOrderStore.orderSuppliers;
        },
        stores() {
            return this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID)).sort(util.sortByName);
        },
        selectedStore(){
            return this.stores.find(s => s.ID == this.order.StoreID);
        },
        departments() {
            return this.$store.state.departmentStore.departments.filter(d => d.Active && auth.hasAccessToDepartment(d.ID)).sort(util.sortByName);
        },
        departmentsInSelectedStore(){
            let departments = this.departments.filter(d => {
                if(!this.selectedStore){
                    return false;
                }

                if(!this.selectedStore.DepartmentIDs){
                    return false;
                }
                
                let selectedStoreContainsDepartment = this.selectedStore.DepartmentIDs.split(",").some(dID => dID == d.ID);
                if(!selectedStoreContainsDepartment){
                    return false;
                }

                return true;
            });

            return departments;
        },
        selectedDepartment(){
            return this.departmentsInSelectedStore.find(d => d.ID == this.order.DepartmentID);
        },
        publicHolidays(){
            return this.$store.state.publicHolidayStore.publicHolidays;
        },
        suppliersLoading(){
            return this.orderSuppliers.updating
                || this.$store.state.storeSupplierStore.loading;
        },
        supplierLoadError(){
            return this.$store.state.storeSupplierStore.loadError;
        },
        orderHasSuppliers(){
            if(this.orderSuppliers.productsWithSuppliers.length == 0){
                return false;
            }

            return true;
        }
    },
    watch: {
    },
    methods: {
        allowedDates(val){
            var date = new Date(val);

            if(date <= Date.now()){
                return false;
            }

            let dateIsPublicHoliday = this.publicHolidays.find(pH => {
                let publicHoliday = new Date(pH.Date);

                if(publicHoliday.getDate() == date.getDate()
                    && publicHoliday.getMonth() == date.getMonth()
                    && publicHoliday.getFullYear() == date.getFullYear()){
                    return true;
                }
            });
            if(dateIsPublicHoliday){
                return false;
            }

            return true;
        },
        showInfo(){
            this.infoVisible = true;
        },
        onDateInput(){
            this.datePickerMenu = false;
            this.orderDetailsChanged();
        },
        orderDetailsChanged() {
            // Check if this invalidates the selected department
            if(this.order.DepartmentID && !this.selectedDepartment){
                // Department now needs to be reselected
                this.order.DepartmentID = null;
                this.$refs.orderForm.resetValidation();
            }
            const department = this.departmentsInSelectedStore.find(d => d.ID == this.order.DepartmentID);
            if(department){
                 
                if(department.Name == "Organics"){
                    this.showStockEntry = true;
                }
                else{
                    this.showStockEntry = false;
                }
            }

            this.placeOrderError = "";

            let that = this;

            this.$store.dispatch("placeOrderStore/orderDetailsChanged").then(
                function(result) {
                    
                },
                function(error) {
                    that.placeOrderError = error;
                }
            );
        },
        saveOrder(){
            if(this.$refs.orderItemsForm){
                this.$refs.orderItemsForm.resetValidation();
            }
            this.$emit("onSave");
        },
        placeOrder() {
            if(this.$refs.orderItemsForm){
                this.$refs.orderItemsForm.resetValidation();
            }
            this.$store.dispatch("placeOrderStore/updateOrdersProductCommentToOrder");
            this.$emit("onConfirm",this.showStockEntry);
        },
        printOrderSheet(){
            if(this.$refs.orderItemsForm){
                this.$refs.orderItemsForm.resetValidation();
            }
            this.$emit("onPrintOrderSheet",this.showStockEntry);
        },
        formatDate(dateString){
            if(!dateString){
                return;
            }

            let date = new Date(dateString);

            let day = date.getDate();
            let month = date.getMonth() + 1;
            let year = date.getFullYear();

            return day + "/" + month + "/" + year;
        },
    },
    created(){
        this.orderDetailsChanged();
    }
};
</script>

<style>

</style>
